module.exports = __webpack_public_path__ + "img/default.8e2370e6.jpg";